<template>
    <div class="form-overlay music-content" :class="position">
        <audio @canplaythrough="(e) => e.target.volume = '0.5'" :ref="`music-preview`"></audio>
        <div class="steep1" v-if="musicSelected">
            <div class="content">
                <div class="list-item hide-scrollbar">
                    <div
                        class="item"
                        style="margin-bottom: 0px;"
                    >
                        <div
                            class="img"
                            @click.stop="toggleMusic(musicSelected)"
                            :class="{play : musicSelected.track && urlMusicPlaying == musicSelected.track.progressive_download_url}">
                            <img :src="musicSelected.track ? musicSelected.track.cover_artwork_thumbnail_uri : ''" alt="">
                        </div>

                        <div class="info">
                            <p class="name">{{ musicSelected.track ? musicSelected.track.title : '' }}</p>
                            <p class="author">{{ musicSelected.track ? musicSelected.track.display_artist : '' }} · {{ formatDuration(musicSelected.track ? musicSelected.track.duration_in_ms : 0) }} · {{ formatCount(musicSelected.tiktok_original ? musicSelected.tiktok_original.user_count : 0) }} posts</p>
                        </div>
                        <i class="fa-regular fa-xmark" @click="removeMusic"></i>
                    </div>

                    <template>
                        <CursorMusic
                            :music="musicSelected"
                            :defaultRangeDuration="models.duration.toString()"
                            :defaultStart="models.start"
                            :durationLock="durationLock"
                            :videoDurationMs="videoDurationMs"
                            @rangeDurationChange="rangeDurationChange"
                            @startChange="startChange"
                        />

                        <div class="balance">
                            <h4>Balance son</h4>
                            <div class="inputRange">
                                <input type="range" min="-1" max="1" step="0.01" v-model="balance">
                            </div>
                            <div class="labels">
                                <span>Son de la Vidéo ({{ videoPct }}%)</span>
                                <span>Son de la Musique ({{ musicPct }}%)</span>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>

        <div class="steep2" v-else>
            <div class="content">
                <div class="input">
                    <i class="fa-regular fa-magnifying-glass"></i>
                    <input placeholder="Rechercher une musique" v-model="textSearch" v-on:keyup.enter="runSearch">
                </div>
                <div v-if="!textSearch" class="navigation">
                    <div v-for="[key, feed] in Object.entries(feeds)" @click="selectFeed(key)" class="item-nav" :class="{active: selectedFeed === key}" :key="key">{{ feed.name }}</div>
                </div>
                <div class="list-item hide-scrollbar" @scroll="onScroll">
                    <span class="loader" v-if="stateLoader && !loadingMore"></span>
                    <p v-else-if="!stateLoader && listMusics.length === 0" class="no-result">Aucune musique trouvée</p>
                    <template v-else>
                        <div class="item" v-for="(music, index) in listMusics" @click="selectMusic(music)" :key="`tiktok-music${index}`">
                            <div
                                class="img"
                                @click.stop="toggleMusicRaw(music)"
                                :class="{play : urlMusicPlaying == music.audio_url}"
                            >
                                <img :src="music.cover_url" alt="">
                            </div>

                            <div class="info">
                                <p class="name">{{ music.title }}</p>
                                <p class="author">{{ music.author }} · {{ formatDuration(music.duration) }} · {{ formatCount(music.user_count) }} posts</p>
                            </div>
                        </div>
                    </template>
                    <div class="loading-more" v-if="loadingMore">
                        <i class="fa-solid fa-spinner fa-spin"></i>
                    </div>
                </div>
            </div>
        </div>
        <div class="btn-secondary" @click="close">Fermer</div>
    </div>
</template>

<script>
    import { EventBus } from '@/event-bus';
    import CursorMusic from '../cursorMusic.vue';
    import mixinPost from '@/components/mixins/Posts.vue'

    export default {
        mixins: [mixinPost],
        components: {
            CursorMusic,
        },
        props: {
            musicSelected: {
                type: Object,
                default: undefined
            },
            position: {
                type: String,
                default: 'left'
            },
            durationLock: Number,
            videoDurationMs: {
                type: Number,
                default: 0,
            }
        },

        data() {
            return {
                balance: 0,
                stateLoader: false,
                listMusics: [],
                urlMusicPlaying: null,
                selectedFeed: 'france',
                feeds: {
                    france: { name: 'Top France', region: 'FR' },
                    global: { name: 'Top Global', region: 'Global' },
                },
                currentCursor: 0,
                hasMore: false,
                loadingMore: false,
                textSearch: '',
                searchCursor: 0,
                searchTimeout: null,

                models: {
                    duration: this.musicSelected && this.musicSelected.duration ? this.musicSelected.duration : 15000,
                    start: this.musicSelected && this.musicSelected.start ? this.musicSelected.start : 0,
                }
            }
        },

        watch: {
            textSearch(newVal) {
                if (this.searchTimeout) clearTimeout(this.searchTimeout)
                this.searchCursor = 0
                this.listMusics = []
                this.hasMore = false
                if (!newVal || !newVal.trim()) {
                    this.stateLoader = false
                    this.currentCursor = 0
                    this.fetchTiktokMusicChart()
                    return
                }
                this.stateLoader = true
                this.searchTimeout = setTimeout(() => { this.runSearch() }, 500)
            }
        },

        mounted() {
            if (!this.musicSelected) {
                this.fetchTiktokMusicChart()
            }
            if (this.musicSelected && this.musicSelected.balance !== undefined) {
                this.balance = this.musicSelected.balance
            }
        },

        methods: {
            rangeDurationChange(data) {
                this.models.duration = data
            },
            startChange(data) {
                this.models.start = data
            },

            selectFeed(feed) {
                this.selectedFeed = feed
                this.listMusics = []
                this.currentCursor = 0
                this.hasMore = false
                this.fetchTiktokMusicChart()
            },

            async fetchTiktokMusicChart() {
                const page = this.tiktokConciergeriePage
                if (!page) {
                    this.listMusics = []
                    return
                }
                if (this.currentCursor > 0) {
                    this.loadingMore = true
                } else {
                    this.stateLoader = true
                }
                try {
                    const region = this.feeds[this.selectedFeed].region
                    const res = await this.getMusicTiktok(this.currentCursor, region, page.id)
                    if (this.currentCursor > 0) {
                        this.listMusics = [...this.listMusics, ...(res.body.musics || [])]
                    } else {
                        this.listMusics = res.body.musics || []
                    }
                    this.hasMore = res.body.hasMore && this.currentCursor === 0
                } catch (e) {
                    console.error('fetchTiktokMusicChart error', e)
                } finally {
                    this.stateLoader = false
                    this.loadingMore = false
                }
            },

            onScroll(e) {
                const el = e.target
                if (el.scrollTop + el.clientHeight >= el.scrollHeight - 50 && this.hasMore && !this.loadingMore) {
                    if (this.textSearch && this.textSearch.trim()) {
                        this.searchCursor = this.listMusics.length
                        this.runSearch()
                    } else {
                        this.currentCursor = 30
                        this.fetchTiktokMusicChart()
                    }
                }
            },

            async runSearch() {
                const page = this.tiktokConciergeriePage
                if (!page || !this.textSearch || !this.textSearch.trim()) return
                if (this.searchCursor > 0) {
                    this.loadingMore = true
                } else {
                    this.stateLoader = true
                }
                try {
                    const res = await this.searchMusicTiktok(this.textSearch.trim(), this.searchCursor, page.id)
                    const newItems = res.body.musics || []
                    this.listMusics = this.searchCursor > 0 ? [...this.listMusics, ...newItems] : newItems
                    this.hasMore = !!res.body.hasMore
                } catch (e) {
                    console.error('runSearch error', e)
                } finally {
                    this.stateLoader = false
                    this.loadingMore = false
                }
            },

            formatCount(count) {
                if (!count) return '0'
                if (count >= 1000000) return (count / 1000000).toFixed(1).replace(/\.0$/, '') + 'M'
                if (count >= 1000) return (count / 1000).toFixed(1).replace(/\.0$/, '') + 'K'
                return count.toString()
            },

            formatDuration(ms) {
                const sec = Math.round((ms || 0) / 1000)
                const min = Math.floor(sec / 60)
                const s = sec % 60
                return min > 0 ? min + 'm' + (s < 10 ? '0' : '') + s + 's' : sec + 's'
            },

            selectMusic(music) {
                const adapted = {
                    track: {
                        title: music.title,
                        display_artist: music.author,
                        progressive_download_url: music.audio_url,
                        cover_artwork_thumbnail_uri: music.cover_url,
                        duration_in_ms: music.duration,
                        highlight_start_times_in_ms: [],
                        audio_asset_id: music.id,
                    },
                    tiktok_original: music
                }
                if (this.urlMusicPlaying !== music.audio_url) this.toggleMusicRaw()
                EventBus.$emit("eventClickSelectTiktokMusic", adapted)
            },

            removeMusic() {
                this.toggleMusic()
                EventBus.$emit("eventRemoveSelectTiktokMusic")
                this.fetchTiktokMusicChart()
            },

            toggleMusic(music) {
                let audio = this.$refs['music-preview']

                if (!music) {
                    this.urlMusicPlaying = null
                    audio.pause()
                    return
                }

                const url = music.track ? music.track.progressive_download_url : ''
                if (url === audio.src) {
                    if (audio.paused) {
                        audio.play()
                        this.urlMusicPlaying = url
                    } else {
                        audio.pause()
                        this.urlMusicPlaying = null
                    }
                } else {
                    audio.src = url
                    audio.currentTime = 0
                    this.urlMusicPlaying = url
                    audio.play()
                }
            },

            toggleMusicRaw(music) {
                let audio = this.$refs['music-preview']

                if (!music) {
                    this.urlMusicPlaying = null
                    audio.pause()
                    return
                }

                const url = music.audio_url
                if (url === audio.src) {
                    if (audio.paused) {
                        audio.play()
                        this.urlMusicPlaying = url
                    } else {
                        audio.pause()
                        this.urlMusicPlaying = null
                    }
                } else {
                    audio.src = url
                    audio.currentTime = 0
                    this.urlMusicPlaying = url
                    audio.play()
                }
            },

            close() {
                if (this.musicSelected) {
                    const tt = this.musicSelected.tiktok_original || this.musicSelected
                    EventBus.$emit("eventClickSelectTiktokMusic", {
                        ...this.musicSelected,
                        id: tt.id,
                        title: tt.title,
                        author: tt.author,
                        audio_url: tt.audio_url,
                        cover_url: tt.cover_url,
                        duration: this.models.duration,
                        start: this.models.start,
                        balance: parseFloat(this.balance),
                    })
                }
                this.$emit('close')
            }
        },

        computed: {
            allPages() {
                return this.$store.getters['selectPage/selectPageAllPages']
            },
            pagesSelected() {
                return this.$store.getters['selectPage/selectPagePageSelected'].map(id => this.allPages[id])
            },
            tiktokConciergeriePage() {
                return this.pagesSelected.find(p => p && p.network === 'tiktok' && p.story_config && p.story_config.created)
            },
            videoPct() {
                return Math.round((1 - parseFloat(this.balance)) / 2 * 100)
            },
            musicPct() {
                return Math.round((1 + parseFloat(this.balance)) / 2 * 100)
            }
        },

        beforeDestroy() {
            if (this.searchTimeout) clearTimeout(this.searchTimeout)
            const audio = this.$refs['music-preview']
            if (audio) {
                audio.pause()
                audio.removeAttribute('src')
                audio.load()
            }
        }
    }
</script>
